import { Injectable } from '@angular/core';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiUrl } from '..';

@Injectable({
  providedIn: 'root'
})
export class MailService {
  private apiUrl = getApiUrl();

  // Set the headers
  config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  constructor() {
    console.log(this.apiUrl);
  }

  async sendMail(formData: FormData): Promise<AxiosResponse<unknown>> {
    const url = `${this.apiUrl}/api/v1/send-email`;

    try {
      const response = await axios.post(url, formData, {
        ...this.config,
        headers: {
          ...this.config?.headers,
          'Content-Type': 'multipart/form-data', // ensures file is sent
        },
      });

      return response;
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  }
}
